import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const AllPosts = ({ posts }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 6; // Showing 6 posts per page now
  const validPosts = Array.isArray(posts) ? posts : [];
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = validPosts.slice(indexOfFirstPost, indexOfLastPost);
  const totalPages = Math.ceil(validPosts.length / postsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  if (!validPosts || validPosts.length === 0) {
    return (
      <section className="all-posts">
        <h2>All Posts</h2>
        <p>No posts available.</p>
      </section>
    );
  }

  return (
    <section className="all-posts">
      <h2>All Posts</h2>
      <div className="post-grid"> {/* Using a grid layout like the others */}
        {currentPosts.map((post) => (
          <article key={post.id} className="blog-post-card"> {/* Using similar card styling */}
            <Link to={post.link}>
              <div className="post-image">
                <img src={post.imageUrl} alt={post.title} loading="lazy"/>
              </div>
              <div className="post-details">
                <h3>{post.title}</h3>
                <p className="excerpt">{post.excerpt.substring(0, 100)}...</p> {/* Shorter excerpt */}
                <div className="post-meta">
                  <span className="author">{post.author}</span>
                  <span className="date">
                    {new Date(post.publishedDate).toLocaleDateString('en-IN', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })}
                  </span>
                </div>
                <span className="read-more">Read More &rarr;</span>
              </div>
            </Link>
          </article>
        ))}
      </div>
      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span>
            {currentPage} / {totalPages}
          </span>
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}
    </section>
  );
};

export default AllPosts;